import CommentAdd from "./CommentTypes/CommentAdd";
import CommentUpdate from "./CommentTypes/CommentUpdate";
import CommentDelete from "./CommentTypes/CommentDelete";
import React from "react";
export default function CommentsHistoryList({
   users,
   comments,
   sort,
   projectId,
}) {
   if (comments.length === 0) {
      return null;
   }
   // Make sure different components handle different types of comments
   const renderedList = comments.map((comment) => {
      let historyList;
      const username = users[comment.user];
      switch (comment.commentType) {
         case "CommunicationCommmentAdd":
            return (
               <CommentAdd
                  username={username}
                  comment={comment}
                  key={comment.time}
                  projectId={projectId}
               />
            );

         case "CommunicationCommmentUpdate":
            historyList = comments.filter((comm) => {
               return comm.id === comment.id;
            });

            return (
               <CommentUpdate
                  username={username}
                  sort={sort}
                  comment={comment}
                  key={comment.time}
                  historyList={historyList}
                  projectId={projectId}
               />
            );

         case "CommunicationCommmentDelete":
            historyList = comments.filter((comm) => {
               return comm.id === comment.id;
            });
            return (
               <CommentDelete
                  username={username}
                  sort={sort}
                  comment={comment}
                  key={comment.time}
                  historyList={historyList}
                  projectId={projectId}
               />
            );

         default:
            return null;
      }
   });

   return <section className={"comment-list"}>{renderedList}</section>;
}
